import { TableColumn as TableColumnWSR } from '@wix/design-system/dist/types/Table';
import { ActionsCell } from '../ActionsCell';
import { FiltersMap } from '@wix/bex-core';

export interface CollectionTableBaseCommonProps<T, F extends FiltersMap> {
  /**
   * Adds a [`<TableActionCell />`](https://www.docs.wixdesignsystem.com/?path=/story/components-lists-table--tableactioncell) as last column.<br>
   * Must be a [ActionsCellProps](/pages/cairo/?path=/story/components-collection-features--actionscellprops) object, or a function that returns a [ActionsCellProps](/pages/cairo/?path=/story/components-collection-features--actionscellprops) object.<br>
   * @external
   */
  actionsCell?: ActionsCell<T, F>;
  /**
   * Width for the column that contains the `actionsCell` component
   * @external
   */
  actionsCellWidth?: string | number;
  /**
   * Extra columns props for the actions cell
   * @external
   */
  actionsCellProps?: Partial<Omit<TableColumnWSR<T>, 'render' | 'style'>>;
}
